import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DBConnectorService } from '../service/test.service';
import { PredictService } from './../service/predict.service';
import { SectorModel } from './../service/sector.model';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})

export class LayoutComponent implements OnInit {
  tabSelect = 'home';
  username: any;
  show_name: any;
  UserCheck: any = {};
  Admin: boolean;
  RoleID: number;
  Heading = 'Dashboard';
  showLoader = false;
  public sectors = ['Choose sectors'];
  public models = [];
  public SectorName = null;
  public ModelName = null;
  public sectormodel = new SectorModel;

  constructor(private sanitizer: DomSanitizer,
    private dbconnectorService: DBConnectorService,
    private router: Router,
    private msalService: MsalService,
    private predictservice: PredictService) {
  }

  isAdmin() {
    this.showLoader = true;
    console.log('Admin called');
    const data = {
      'UserName': this.username,
      'IpAddress': this.dbconnectorService.ipaddress
    };
    this.dbconnectorService.isadmin(data)
      .subscribe((res) => {
        this.UserCheck = res;
        console.log(this.UserCheck);
        if (this.UserCheck['UserExists'] === true) {
          console.log('UserExists');
          this.RoleID = this.UserCheck['RoleID'];
          this.dbconnectorService.RoleID = this.UserCheck['RoleID'];
          this.dbconnectorService.Admin = this.Admin;
          this.getUsersector();
          if (this.RoleID === 3) {
            this.onSelect('predict');
            this.router.navigate(['/Predict']);
          } else {
            this.router.navigate(['/Home']);
          }
        }
        if (this.UserCheck['UserExists'] === false) {
          console.log('User does not exist');
          this.router.navigate(['/No_user']);
          // alert('User does not exist');
          // this.logout();
        }

        this.showLoader = false;
      });
  }

  getsectors() {
    this.dbconnectorService.getsectors()
      .subscribe(res => this.sectors = res);

  }
  getUsersector() {
    const data = { 'UserName': this.username };
    this.dbconnectorService.getUserSector(data)
      .subscribe(res => this.sectors = res);
  }

  getmodels() {
    console.log(this.SectorName);
    this.dbconnectorService.getmodels(this.SectorName)
      .subscribe(res => this.models = res);

  }


  PassSectorModel() {
    this.dbconnectorService.setSectorModel(this.SectorName, this.ModelName);

    this.sectormodel.SectorName = this.SectorName;
    this.sectormodel.ModelName = this.ModelName;
    this.predictservice.contraStatusCheck(this.sectormodel)
      // .subscribe(
      //   (data) => {
      //     var dataSectroData = data;
      //     //this.showContraCheckBox = data;
      //   });

    //shivam
  }

  onSelect(feature: string) {
    this.tabSelect = feature;
    if (this.tabSelect === 'home') {
      this.Heading = 'Dashboard';
    }
    if (this.tabSelect === 'train') {
      this.Heading = 'Train the System';
    }
    if (this.tabSelect === 'predict') {
      this.Heading = 'Predict the Tax codes';
    }
    if (this.tabSelect === 'manageUser') {
      this.Heading = 'Manage Components';
    }
    if (this.tabSelect === 'config') {
      this.Heading = 'Rules & Exceptions';
    }

  }

  getStyle(newstyle: string) {
    if (this.tabSelect === newstyle) {
      const style = 'color:#333!important;background-color:#FFE600!important;font-weight:bold!important;';
      return this.sanitizer.bypassSecurityTrustStyle(style);
    }
  }

  getStyleImg(newstyle: string) {
    if (this.tabSelect === newstyle) {
      const style = 'background-color:#333!important;';
      return this.sanitizer.bypassSecurityTrustStyle(style);
    }
  }

  logout() {
    const data = {
      'UserName': this.username,
      'IpAddress': this.dbconnectorService.ipaddress
    };
    this.dbconnectorService.loggingout(data)
      .subscribe((res) => {
        this.msalService.logout();
        sessionStorage.removeItem('firstName');
        sessionStorage.removeItem('lastName');
        sessionStorage.removeItem('emailId');
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('IsAdmin');
        sessionStorage.removeItem('IsAuthenticated');
        sessionStorage.removeItem('RoleID');
        sessionStorage.removeItem('loggedinTime');
        window.sessionStorage.clear();
        this.router.navigate(['/logout']);
      });
  }

  login() {
    this.msalService.loginRedirect();
    //localStorage.setItem('currentUser', JSON.stringify(this.adalService.userInfo.profile));
  }

  ngOnInit() {
    if (this.msalService.instance.getActiveAccount()) { 
      this.dbconnectorService.setToken();
    // if (sessionStorage.getItem('IsAuthenticated')) { 
      this.username = this.msalService.instance.getActiveAccount().username
      
      this.dbconnectorService.getUserProfile().subscribe(data => {
        this.show_name = data.givenName;
      })

      
      this.dbconnectorService.username = this.username;
      this.dbconnectorService.ipaddress = ''//this.adalService.userInfo.profile['ipaddr'];
      // this.dbconnectorService.ipaddress = '11.11.1.1';
      console.log('User Name: ' + this.show_name);
      console.log('User Ip Address: ' + this.dbconnectorService.ipaddress);
      // let resource = this.adalService.GetResourceForEndpoint('/api/ManageModel/DeleteConfirmedModel');
      // console.log('resource:' + resource)
      // this.adalService.acquireToken(resource).subscribe(p => { console.log('acquire token: '+p) })
      // console.log('cached token:' + this.adalService.getCachedToken(resource))
      // console.log('UserInfo:  ' + JSON.stringify(this.adalService.userInfo.profile));
      console.log('Build Date: 27/02/2018 16:47, Status: Trying async on Predict page. Trying async on Train page');
      this.isAdmin();

      // this.Admin = (sessionStorage.getItem('IsAdmin')).toLowerCase() === 'true' ? true : false;
      // this.RoleID = (sessionStorage.getItem('RoleID'));

      this.dbconnectorService.username = this.username;
      // this.dbconnectorService.ipaddress = '';
      console.log('User Name: ' + this.show_name);
      console.log('User Ip Address: ' + this.dbconnectorService.ipaddress);
      // if (this.adalService.userInfo.isAuthenticated) {
      //   this.getRequiredData();
      // }

      // this.Admin = true;
      // this.UserCheck['UserExists'] = true;
      // this.username = 'admin1@ey.com' ;
      // this.dbconnectorService.username = this.username;
      // this.dbconnectorService.Admin = true;
      // this.getUsersector();

    }
  }

  getRequiredData() {

    console.log('getRequiredData called');

    const data = {
      'UserName': this.username,
      'IpAddress': this.dbconnectorService.ipaddress
    };

    this.getUsersector();
    // if (this.Admin == false || this.RoleID==='3') {
    if (this.RoleID === 3) {
      this.onSelect('predict');
      this.router.navigate(['/Predict']);
    } else {
      this.router.navigate(['/Home']);
    }
  }

  processTerminate() {
    this.dbconnectorService.terminateProcess()
      .subscribe(
        (data) => {
          console.log(data);
          alert(data._Status);
        });
  }

  loginAgainFromTimeout() {
    this.RoleID = parseInt(sessionStorage.getItem('RoleID'));
    if (this.RoleID === 3) {
      this.onSelect('predict');
      this.router.navigate(['/Predict']);
    } else {
      this.onSelect('home');
      this.router.navigate(['/Home']);
    }
  }
}
